import API from '../config/api';
import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { Navbar, Container, NavDropdown, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/* Minimal navbar for the delivery portal — brand + notifications only. */
function DeliveryNavbar() {
  const [notifications, setNotifications] = useState([]);

  const partner = (() => {
    try {
      return JSON.parse(localStorage.getItem('deliveryInfo'));
    } catch {
      return null;
    }
  })();

  const fetchNotifications = async () => {
    if (!partner?.email) return;
    try {
      const { data } = await axios.get(
        `${API}/notifications/${partner.email}`
      );
      setNotifications(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markRead = async (id) => {
    try {
      await axios.put(`${API}/notifications/read/${id}`);
      setNotifications((prev) =>
        prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const unread = notifications.filter((n) => !n.isRead).length;
  const partnerName = partner?.name || partner?.email?.split('@')[0] || 'Partner';
  const initial = partnerName.charAt(0).toUpperCase();

  return (
    <Navbar variant="dark" className="dp-navbar py-2">
      <Container fluid className="px-3 px-md-4 d-flex justify-content-between align-items-center">
        <Navbar.Brand
          as={Link}
          to="/delivery"
          className="fw-bold d-flex align-items-center gap-2 dp-navbar-brand"
        >
          <span className="dp-logo-badge">🛵</span>
          <span className="d-flex flex-column lh-1">
            <span className="dp-navbar-text">PoojaMart</span>
            <span className="dp-navbar-tag">Delivery Partner</span>
          </span>
        </Navbar.Brand>

        {partner && (
          <div className="d-flex align-items-center gap-2 gap-md-3">
            <div className="dp-partner-chip">
              <span className="dp-avatar">{initial}</span>
              <span className="d-none d-sm-flex flex-column lh-1">
                <span className="dp-partner-name">{partnerName}</span>
                <span className="dp-partner-status">
                  <span className="dp-status-dot" /> Online
                </span>
              </span>
            </div>

            <NavDropdown
              align="end"
              id="dp-notif"
              className="dp-notif-dd"
              title={
                <span className={'dp-bell position-relative d-inline-block' + (unread > 0 ? ' dp-bell-active' : '')}>
                  🔔
                  {unread > 0 && (
                    <Badge
                      bg="danger"
                      pill
                      className="position-absolute"
                      style={{
                        top: '-8px',
                        right: '-12px',
                        fontSize: '0.62rem'
                      }}
                    >
                      {unread}
                    </Badge>
                  )}
                </span>
              }
            >
            <div className="dp-notif-panel">
              <div className="dp-notif-header">
                🔔 Notifications
                {unread > 0 && <span className="dp-notif-new">{unread} new</span>}
              </div>

              {notifications.length === 0 ? (
                <div className="dp-notif-empty">
                  <div style={{ fontSize: '1.8rem' }}>🔕</div>
                  <small>No notifications yet</small>
                </div>
              ) : (
                notifications.slice(0, 8).map((n) => (
                  <button
                    key={n._id}
                    type="button"
                    className={
                      'dp-notif-item ' + (!n.isRead ? 'dp-notif-unread' : '')
                    }
                    onClick={() => markRead(n._id)}
                  >
                    <div className="dp-notif-title">{n.title}</div>
                    <div className="dp-notif-msg">{n.message}</div>
                  </button>
                ))
              )}
            </div>
          </NavDropdown>
          </div>
        )}
      </Container>

      <style>{dpNavStyles}</style>
    </Navbar>
  );
}

const dpNavStyles = `
  .dp-navbar {
    position: relative;
    background:
      radial-gradient(900px 200px at 12% -40%, rgba(251,191,36,0.22), transparent 70%),
      linear-gradient(90deg, #3b0764 0%, #7c2d12 45%, #9a3412 70%, #b45309 100%);
    background-size: 160% 100%;
    animation: dpGradient 16s ease infinite;
    border-bottom: 1px solid rgba(251,191,36,0.35);
    box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  }
  @keyframes dpGradient {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  /* Shimmering divine gold thread along the top */
  .dp-navbar::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg,
      transparent, #fde68a 20%, #f59e0b 50%, #fde68a 80%, transparent);
    background-size: 200% 100%;
    animation: dpThread 6s linear infinite;
  }
  @keyframes dpThread {
    from { background-position: 200% 0; }
    to { background-position: -200% 0; }
  }

  .dp-navbar-brand { font-size: 1.4rem; }
  .dp-logo-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 44px; height: 44px; border-radius: 50%; font-size: 1.3rem;
    background: radial-gradient(circle at 35% 30%, #fef3c7, #f59e0b 60%, #b45309);
    box-shadow:
      0 0 0 2px rgba(253,230,138,0.55),
      0 0 18px rgba(245,158,11,0.6),
      inset 0 1px 3px rgba(255,255,255,0.6);
    animation: dpGlow 3.5s ease-in-out infinite;
  }
  @keyframes dpGlow {
    0%, 100% { box-shadow: 0 0 0 2px rgba(253,230,138,0.55), 0 0 14px rgba(245,158,11,0.45), inset 0 1px 3px rgba(255,255,255,0.6); }
    50% { box-shadow: 0 0 0 2px rgba(253,230,138,0.8), 0 0 26px rgba(245,158,11,0.8), inset 0 1px 3px rgba(255,255,255,0.6); }
  }
  .dp-navbar-text {
    font-size: 1.35rem; font-weight: 800;
    background: linear-gradient(90deg, #fde68a, #fbbf24 40%, #fb923c);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 0.5px;
  }
  .dp-navbar-tag {
    font-size: 0.58rem; font-weight: 600; letter-spacing: 2.5px;
    text-transform: uppercase; color: rgba(253,230,138,0.75); margin-top: 3px;
  }

  .dp-partner-chip {
    display: flex; align-items: center; gap: 9px;
    padding: 5px 12px 5px 6px; border-radius: 40px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    backdrop-filter: blur(6px);
    transition: background 0.2s ease, border-color 0.2s ease;
  }
  .dp-partner-chip:hover {
    background: rgba(255,255,255,0.14);
    border-color: rgba(251,191,36,0.5);
  }
  .dp-avatar {
    display: inline-flex; align-items: center; justify-content: center;
    width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
    font-weight: 800; font-size: 0.95rem; color: #111827;
    background: linear-gradient(135deg, #fbbf24, #f97316);
    box-shadow: 0 2px 8px rgba(249,115,22,0.45);
  }
  .dp-partner-name { color: #fff; font-weight: 700; font-size: 0.85rem; }
  .dp-partner-status {
    display: flex; align-items: center; gap: 5px; margin-top: 2px;
    font-size: 0.68rem; color: rgba(255,255,255,0.65);
  }
  .dp-status-dot {
    width: 7px; height: 7px; border-radius: 50%; background: #22c55e;
    box-shadow: 0 0 0 0 rgba(34,197,94,0.7); animation: dpPulse 2s infinite;
  }
  @keyframes dpPulse {
    0% { box-shadow: 0 0 0 0 rgba(34,197,94,0.6); }
    70% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
    100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
  }

  .dp-bell { transition: transform 0.2s ease; }
  .dp-notif-dd:hover .dp-bell { transform: scale(1.12); }
  .dp-bell-active { animation: dpRing 2.5s ease-in-out infinite; transform-origin: 50% 0; }
  @keyframes dpRing {
    0%, 88%, 100% { transform: rotate(0); }
    90% { transform: rotate(14deg); }
    93% { transform: rotate(-11deg); }
    96% { transform: rotate(7deg); }
  }

  .dp-notif-dd .dropdown-toggle { color: #fff !important; font-size: 1.15rem; }
  .dp-notif-dd .dropdown-toggle::after { display: none; }
  .dp-notif-dd .dropdown-menu {
    border: none;
    border-radius: 14px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.18);
    padding: 0;
    overflow: hidden;
    margin-top: 8px;
  }
  .dp-notif-panel { width: 320px; max-width: 90vw; }
  .dp-notif-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 16px; color: #fff; font-weight: 700;
    background: linear-gradient(120deg, #3b0764, #9a3412 60%, #ea580c);
  }
  .dp-notif-new {
    background: #fbbf24; color: #111827; font-size: 0.7rem;
    font-weight: 700; border-radius: 30px; padding: 3px 10px;
  }
  .dp-notif-item {
    display: block; width: 100%; text-align: left; border: none;
    background: #fff; padding: 12px 16px; border-bottom: 1px solid #f1f5f9;
    cursor: pointer; transition: background 0.15s ease;
  }
  .dp-notif-item:hover { background: #fff7ed; }
  .dp-notif-unread { background: #fff7ed; }
  .dp-notif-title { font-weight: 700; font-size: 0.86rem; color: #1e293b; }
  .dp-notif-msg { font-size: 0.8rem; color: #64748b; margin-top: 2px; }
  .dp-notif-empty { text-align: center; padding: 24px 16px; color: #64748b; }

  /* Mobile: keep the notification panel within the screen */
  @media (max-width: 575.98px) {
    .dp-navbar-text { font-size: 1.15rem; }
    .dp-logo-badge { width: 40px; height: 40px; font-size: 1.2rem; }
    .dp-notif-dd .dropdown-menu {
      position: absolute !important;
      left: auto !important;
      right: 0 !important;
      transform: none !important;
      inset: auto !important;
    }
    .dp-notif-panel { width: 84vw; max-width: 84vw; }
    .dp-notif-item .dp-notif-title,
    .dp-notif-item .dp-notif-msg { word-break: break-word; }
  }
`;

export default DeliveryNavbar;
